/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import { get } from 'lodash';
import moment from 'moment';

import TenantAssessmentAction from './TenantAssessmentAction';
import Note from '../../Dashboard/Candidates/CandidatesList/AllCandidates/CandidateGridCard/Note';
import InviteCandidateButton from './InviteCandidateButton';
import UserWithAvatar from './UserWithAvatar';
import CandidateBooleanFavorite from './CandidateBooleanFavorite';
import CompanyBooleanFavorite from './CompanyBooleanFavorite';
import CandidateFavorites from '../../Dashboard/Jobs/MyJobs/JobDetails/CandidateFavorites';
import HiringStages from './HiringStages';
import ResumeCell from './ResumeCell';
import Role from '../Role';
import HiringPipelineValue from '../HiringPipelineValue';
import SubmitCandidateButton from './SubmitNewCandidateButton';
import getResizedImageUrl from '../../../helpers/getResizedImageUrl';
import getResizedImageLogoUrl from '../../../helpers/getResizedImageLogoUrl';
import DaysFromCreation from './DaysFromCreation';
import JobStatus from './JobStatus';
import CompanyStatus from './CompanyStatus';
import InterviewInfo from './InterviewInfo';
import HiringSubStatus from './HiringSubStatus';
import { useUserStore } from '../../../store';

export default function Td({ classes, column, row, refetch }) {
  let content;
  const screeningAvailable = useUserStore((state) => state.screeningAvailable);
  const isAgency = useUserStore((state) => state.isAgency);
  const isClient = useUserStore((state) => state.isClient);
  switch (column.type) {
    case 'scope':
      content = (
        <td>
          <div className={classes.rolesContainer}>
            {get(row, column.field)
              .split(',')
              .map((scope) => (
                <Role key={scope} role={scope} />
              ))}
          </div>
        </td>
      );
      break;
    case 'date':
      content = <td>{moment(get(row, column.field)).format('DD-MMM-YY')}</td>;
      break;
    case 'array':
      content = (
        <td>
          {get(row, column.field)
            ?.map((val) => val.name)
            .join(', ')}
        </td>
      );
      break;
    case 'role':
      content = (
        <td>
          <div className={classes.rolesContainer}>
            {get(row, column.field).map((role) => (
              <Role key={role.id} role={role.name} />
            ))}
          </div>
        </td>
      );
      break;
    case 'cityImage':
      content = (
        <td>
          <img
            style={{
              width: 100,
            }}
            alt="city"
            src={getResizedImageUrl({
              url: `city/${get(row, column.field)}`,
              width: 200,
            })}
          />
        </td>
      );
      break;
    case 'companyLogo':
      content = (
        <td>
          {get(row, column.field) ? (
            <img
              style={{
                width: 100,
              }}
              alt="company"
              src={getResizedImageLogoUrl({
                url: `company/${get(row, column.field)}`,
                width: 200,
              })}
            />
          ) : null}
        </td>
      );
      break;
    case 'picVideo':
      content = (
        <td>
          {row.type === 'Video' ? (
            <video src={row.url} />
          ) : (
            <img alt="" src={`${row.url}?height=98&width=110`} />
          )}
        </td>
      );
      break;
    case 'user':
      content = (
        <td>
          {get(row, `${column.field}.firstName`)}{' '}
          {get(row, `${column.field}.lastName`)}
        </td>
      );
      break;
    case 'primaryManager':
      content = (
        <td>
          {get(row, `${column.field}.firstName`)}{' '}
          {get(row, `${column.field}.lastName`)}
        </td>
      );
      break;
    case 'userWithAvatar':
      content = (
        <td>
          <UserWithAvatar user={get(row, column.field)} />
        </td>
      );
      break;
    case 'jobStatus':
      content = <JobStatus value={get(row, column.field)} />;
      break;
    case 'companyStatus':
      content = <CompanyStatus value={get(row, column.field)} />;
      break;
    case 'hiringPipeline':
      content = (
        <>
          {!isClient && (
            <td align="center">
              <HiringPipelineValue backgroundColor="background: linear-gradient(228.41deg, #00E4AC 0%, #10C5E9 53.88%, #9240DC 106.71%)">
                {get(row, column.field).new}
              </HiringPipelineValue>
            </td>
          )}
          {screeningAvailable && !isClient && (
            <td align="center">
              <HiringPipelineValue backgroundColor="#00E3AB">
                {row.hasAssessment ? get(row, column.field).screen : 'N/A'}
              </HiringPipelineValue>
            </td>
          )}
          {!isClient && (
            <td align="center">
              <HiringPipelineValue backgroundColor="#FFB800">
                {get(row, column.field).interview}
              </HiringPipelineValue>
            </td>
          )}
          {(isAgency || isClient) && (
            <td align="center">
              <HiringPipelineValue backgroundColor="#509EFA">
                {get(row, column.field).clientSubmit}
              </HiringPipelineValue>
            </td>
          )}
          {(isAgency || isClient) && (
            <td align="center">
              <HiringPipelineValue backgroundColor="#00E3AB">
                {get(row, column.field).clientInterview}
              </HiringPipelineValue>
            </td>
          )}
          <td align="center">
            <HiringPipelineValue backgroundColor="#FF2D55">
              {get(row, column.field).offer}
            </HiringPipelineValue>
          </td>
          <td align="center">
            <HiringPipelineValue backgroundColor="#6722D2">
              {get(row, column.field).onboard}
            </HiringPipelineValue>
          </td>
        </>
      );
      break;
    case 'daysFromCreation':
      content = (
        <DaysFromCreation
          value={moment(new Date()).diff(moment(row.createdAt), 'days')}
        />
      );
      break;
    case 'resume':
      content = (
        <td>
          <ResumeCell column={get(row, column.field)} row={row} />
        </td>
      );
      break;
    case 'hiringStages':
      content = (
        <td className={classes.hiringStagesContainer}>
          <HiringStages
            status={row.status}
            subStatus={row.subStatus}
            hasAssessment={!!row?.assignedAssessmentCount}
            row={row}
          />
        </td>
      );
      break;
    case 'favorites':
      content = (
        <td className={classes.hiringStagesContainer}>
          <CandidateFavorites
            favoritesList={get(row, column.field)}
            jobApplicationId={row.id}
            refetch={refetch}
          />
        </td>
      );
      break;
    case 'candidateBooleanFavorite':
      content = (
        <td>
          <CandidateBooleanFavorite
            isFavorite={get(row, column.field)}
            candidateId={row.id}
            refetch={refetch}
            isJobApplication={column.isJobApplication}
          />
        </td>
      );
      break;
    case 'companyBooleanFavorite':
      content = (
        <td>
          <CompanyBooleanFavorite
            isFavorite={get(row, column.field)}
            companyId={row.company.id}
            refetch={refetch}
          />
        </td>
      );
      break;
    case 'hiringSubStatus':
      content = <HiringSubStatus row={row} />;
      break;
    case 'interviewFeedback':
      content = (
        <td>
          <InterviewInfo interview={get(row, column.field)} />
        </td>
      );
      break;
    case 'boolean':
      content = <td>{get(row, column.field) === false ? 'No' : 'Yes'}</td>;
      break;
    case 'count':
      content = (
        <td className={classes.countContainer}>
          {get(row, column.field) && get(row, column.field) > 0 ? (
            <div className={classes.countDark}>
              {get(row, column.field)?.toString()}
            </div>
          ) : (
            <div className={classes.countLight}>0</div>
          )}
        </td>
      );
      break;
    case 'companyCount':
      content = (
        <td className={classes.countContainer}>
          {get(row, column.field) && get(row, column.field) > 0 ? (
            <div className={classes.countDark}>
              {get(row, column.field)?.toString()}
            </div>
          ) : (
            <div className={classes.countLight}>0</div>
          )}
        </td>
      );
      break;
    case 'candidateNote':
      content = (
        <td>
          <div className={classes.candidateNoteContainer}>
            {get(row, column.field) ? (
              <Note
                text={get(row, column.field)}
                style={{ top: 0, right: 'unset', left: 0, position: 'unset' }}
              />
            ) : null}
          </div>
        </td>
      );
      break;
    case 'inviteCandidateButton':
      content = (
        <td>
          <InviteCandidateButton candidateId={get(row, column.field)} />
        </td>
      );
      break;
    case 'submitCandidateButton':
      content = (
        <td>
          <SubmitCandidateButton candidateId={get(row, column.field)} />
        </td>
      );
      break;
    case 'short':
      content = <td className={classes.short}>{get(row, column.field)}</td>;
      break;
    case 'text':
      content = <td>{column.value}</td>;
      break;
    case 'tenantAssessmentAction':
      content = (
        <td>
          <TenantAssessmentAction
            tenantAssessmentProvider={row}
            refetch={refetch}
          />
        </td>
      );
      break;
    default:
      // eslint-disable-next-line no-case-declarations
      let tdContent = get(row, column.field) || column.defaultValue;
      if (column.format) {
        tdContent = column.format(tdContent);
      }
      content = <td style={column.style}>{tdContent}</td>;
  }

  return <>{content}</>;
}
